/**
* AITrace.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { getLocation, generateW3CId } from "@microsoft/1ds-core-js";
var Trace = /** @class */ (function () {
    function Trace(propertiesConfig, id, parentId, name) {
        if (propertiesConfig.enableApplicationInsightsTrace) {
            var self_1 = this;
            self_1.traceId = id || generateW3CId();
            self_1.parentId = parentId;
            self_1.name = name;
            var loc = getLocation();
            if (loc && loc.pathname) {
                self_1.name = loc.pathname;
            }
        }
    }
    return Trace;
}());
export { Trace };
//# sourceMappingURL=Trace.js.map